import { useState } from 'react';
import { Button } from '../button';
import { HistoryOutlined } from '@ant-design/icons';
import { StoreHistoryModal } from './store-history-modal';
import { Text } from '../../utils/text';
import style from './style.module.scss';

export function StoreHistoryBar() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <div className={style.version_history_bar}>
                <div className={`${style.text_section} footnote_description`}>
                    {Text.storeHistoryComponent.description}
                </div>
                <Button variant="tertiary" onClick={() => setIsModalOpen(true)}>
                    {Text.storeHistoryComponent.showHistory}
                    <HistoryOutlined />
                </Button>
            </div>
            <StoreHistoryModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
}
